/**
 * Created by vblanco on 28/08/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino el estado de edicion details
    /* @ngInject */
    function stateConfig($stateProvider) {
        //ESTADO ABSTRACTO

        $stateProvider.state('bibliotecaDetails', {
            parent: 'ejemplarDetails',

            url: '/biblioteca/:idBiblioteca',
            data: {
                pageTitle: 'bibliotecaDetails.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/biblioteca/biblioteca.details.html',
                    controller: 'BibliotecaDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                biblioteca: function (Biblioteca, $stateParams) {
                    return Biblioteca.get({id: $stateParams.idBiblioteca}).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();

